import {FeatureCardVO, LayerVO} from '../api';
import {downloadDocument} from '../api/urls';
import {parseAccessibilityValue} from '../assets/accessibility/accessibilityCodelist';
import {layerColorToCss, ViewportResult} from '../components/search-panel/searchPanelTypes';

/** Názvy atributů, ze kterých se skládá podtitulek kartičky ("ulice, město"). */
const SUBTITLE_ATTRS = ['ulice', 'mesto'];

/**
 * Převede kartu objektu ze serveru (`ServicesApi.getFeatureCards`) na {@link ViewportResult} pro bohaté
 * vykreslení v seznamu (výřez i výsledky hledání). Přístupnost už vyhodnotil server; název bere z atributu
 * dle konfigurace vrstvy (`queryableLabelAttribute`), jinak z property `label`/`title`, jinak ID objektu.
 *
 * Sdíleno mezi {@link useViewportFeatures} (výřezový seznam) a {@link useSearchResultCards} (výsledky hledání),
 * aby karta objektu vypadala v obou místech stejně.
 */
export const mapFeatureCardToViewportResult = (
    card: FeatureCardVO,
    layersConfig: {[key: string]: LayerVO},
    serverContextPath: string,
): ViewportResult => {
    const layerId = card.layerId as number;
    const layerKey = String(layerId);
    const layerConfig = layersConfig[layerKey];
    const props = (card.properties ?? {}) as {[key: string]: unknown};

    const accessibilityCodes = parseAccessibilityValue(card.accessibility);

    const labelKey = layerConfig?.queryableLabelAttribute;
    const labelValue = (labelKey ? props[labelKey] : undefined) ?? props['title'] ?? props['label'] ?? props['title'];
    const label =
        labelValue == null
            ? String(card.featureId)
            : typeof labelValue === 'object'
              ? ((labelValue as {nazev?: string}).nazev ?? (labelValue as {title?: string}).title ?? String(card.featureId))
              : String(labelValue);

    const subtitle =
        SUBTITLE_ATTRS.map(key => props[key])
            .filter(v => v != null && String(v).trim() !== '')
            .map(v => String(v).trim())
            .join(', ') || undefined;

    const imgName = layerConfig?.layerImage ?? layerConfig?.style?.marker;
    const layerImageUrl = imgName ? `${serverContextPath}/api/files/img/${imgName}` : undefined;
    const layerColor = layerColorToCss(layerConfig?.style?.color ?? layerConfig?.iconColor);

    return {
        id: `${layerKey}:${card.featureId}`,
        featureId: String(card.featureId),
        layerId,
        label,
        subtitle,
        layerLabel: layerConfig?.label ?? undefined,
        layerImageUrl,
        photoUrl: card.imageId != null ? `${serverContextPath}${downloadDocument(String(card.featureId), card.imageId)}` : undefined,
        accessibilityCodes,
        layerColor,
    };
};
